import React from 'react'
import Hero from './sections/hero'
import Header from './sections/header'
import Features from './sections/features'
import Pricing from './sections/pricing'
import Footer from './sections/footer'
import Background from './sections/background'

const LandingPage=(props)=>{
  return (
    <div>
      <Background>
        <Header/>
        <Hero/>
      </Background>
      <Features/>
      <Background>
        <Pricing/>
      </Background>
      <Footer/>
    </div>
  )
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/components/home_page/landing/index.js